import { ESdChangeReason, ESearchType, IAction, IActionParameter, ISymbol } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { ReactNode } from "react";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { IActionPanelStatesCanBeUpdatedFromChild, SelectboxInputParameter } from "./action-panel";
import ActionParameterTitle from "./action-parameter-title";
import { SymbolPicker } from "./symbol-picker";

export interface ISearchSymbolsGroupProps {
  action: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild, changeReason?: ESdChangeReason) => void;
}

export interface ISearchSymbolsGroupState {}

class SearchSymbolsGroup extends PureSdComponent<
  ISearchSymbolsGroupProps & IWithSDProps & IWithContextProp,
  ISearchSymbolsGroupState
> {
  constructor(props) {
    super(props);
  }

  handleSelectSymbolPickerValue = (parameter: IActionParameter, symbol: ISymbol, changeReason?: ESdChangeReason) => {
    const params = _.cloneDeep(this.props.parameters);
    const param = params.find((param) => param.name === parameter.name);

    if (param) param.symbol = symbol;

    if (param?.name === "searchType") {
      if (symbol.fixedValue !== ESearchType.RAGSearch.toString()) {
        const sessionIdParam = params.find((p) => p.name === "sessionId");
        if (sessionIdParam) {
          sessionIdParam.symbol = KMainFunctions.getDefaultSymbol(sessionIdParam.Typename);
        }
      }
    }

    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    this.props.updateValues(valuesToUpdate, changeReason);
  };

  renderParameter = (parameter: IActionParameter, selectboxParameter?: SelectboxInputParameter) => {
    if (parameter.isOptionalParameter && !parameter.isExternalVisible) return <></>;
    if (selectboxParameter?.isDynamic === true) return <></>;

    return (
      <div
        className={parameter.isDeletedOnSource === true ? "isDeletedOnSource" : ""}
        key={`searchSymbolsGroup-${this.props.action.id}-${parameter.name}`}
      >
        <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
          <ActionParameterTitle parameter={parameter} showTypeChips={selectboxParameter === undefined} />
        </span>
        <SymbolPicker
          action={this.props.action}
          changeType="onBlur"
          symbol={parameter.symbol}
          valueType={parameter.Typename}
          targetCardinality={parameter.cardinality}
          onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
            this.handleSelectSymbolPickerValue(parameter, symbol, changeReason)
          }
          parameterOptions={selectboxParameter?.options}
          bindingParameter={parameter}
        />
      </div>
    );
  };

  render(): ReactNode {
    return this.props.parameters.map((parameter) => {
      let selectboxParameter: SelectboxInputParameter | undefined;
      const searchTypeParamValue = this.props.parameters.find((param) => param.name === "searchType")?.symbol
        .fixedValue;
      if (parameter.name === "topResult") {
        if (searchTypeParamValue === ESearchType.RAGSearch.toString()) return <></>;
      }
      if (parameter.name === "sessionId") {
        if (searchTypeParamValue !== ESearchType.RAGSearch.toString()) return <></>;
      }
      if (parameter.name === "searchType") {
        selectboxParameter = {
          name: parameter.name,
          options: [
            { label: "Vector Search", value: ESearchType.VectorSearch.toString(), isDefault: true },
            { label: "Exact Vector Search", value: ESearchType.ExactVectorSearch.toString() },
            { label: "RAG Search", value: ESearchType.RAGSearch.toString() }
          ]
        };
      }
      return this.renderParameter(parameter, selectboxParameter);
    });
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return (
      changeReason === ESdChangeReason.DiActionUpdated ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.WFStepMappingChange
    );
  };
}

const searchSymbolsGroup = withSD<ISearchSymbolsGroupProps>(SearchSymbolsGroup);
export { searchSymbolsGroup as SearchSymbolsGroup };
